/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Editor_Sign_HintInputs */

const en_statement_taxonomy_editor_sign_hint = /** @type {(inputs: Statement_Taxonomy_Editor_Sign_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debit (+1) covers assets and costs; credit (-1) covers equity, liabilities and revenue.`)
};

const nl_statement_taxonomy_editor_sign_hint = /** @type {(inputs: Statement_Taxonomy_Editor_Sign_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debet (+1) omvat activa en kosten; credit (-1) omvat eigen vermogen, schulden en opbrengsten.`)
};

/**
* | output |
* | --- |
* | "Debit (+1) covers assets and costs; credit (-1) covers equity, liabilities and revenue." |
*
* @param {Statement_Taxonomy_Editor_Sign_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_sign_hint = /** @type {((inputs?: Statement_Taxonomy_Editor_Sign_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Sign_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_sign_hint(inputs)
	return en_statement_taxonomy_editor_sign_hint(inputs)
});